import { useDogxContext } from '@libs/dogx';

export const useRkVivocyberExperiment = (systemSlug?: string) => {
  const { getExperimentVariant } = useDogxContext();
  const experimentVariant = getExperimentVariant('dx-pix-vivocyber');

  const resultIsWithPixVivocyber = experimentVariant === 'with-pix-vivocyber' && !!systemSlug?.includes('vivo');

  return {
    resultIsWithPixVivocyber,
    origin: resultIsWithPixVivocyber ? 'ac_vivo_pixleto_test' : undefined,
  };
};
